import {
  AppointmentDeactivateActionTypes,
  APPOINTMENT_DEACTIVATE_FAIL,
  APPOINTMENT_DEACTIVATE_LOADING,
  APPOINTMENT_DEACTIVATE_SUCCESS,
  AppointmentDeactivateState,
  APPOINTMENT_DEACTIVATE_UPDATE_API_MSG,
  APPOINTMENT_DEACTIVATE_UPDATE_API_RES,
} from "./ActionTypes";
import { AppointmentDeactivateResponse } from "./Model";

const initialStateGetPosts: AppointmentDeactivateState = {
  loading: false,
  appointmentListRes: {} as AppointmentDeactivateResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const appointmentDeactivateReducer = (
  state = initialStateGetPosts,
  action: AppointmentDeactivateActionTypes
): AppointmentDeactivateState => {
  switch (action.type) {
    case APPOINTMENT_DEACTIVATE_LOADING:
      return {
        ...state,
        loading: true,
        appointmentListRes: {} as AppointmentDeactivateResponse,
      };
    case APPOINTMENT_DEACTIVATE_SUCCESS:
      return {
        ...state,
        loading: false,
        appointmentListRes: action.payload,
        successMsg: action.successMsg,
        status: action.status
      };
    case APPOINTMENT_DEACTIVATE_FAIL:
      return {
        ...state,
        loading: false,
        appointmentListRes: {} as AppointmentDeactivateResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case APPOINTMENT_DEACTIVATE_UPDATE_API_MSG:
      return {
        ...state,
        loading: false,
        appointmentListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case APPOINTMENT_DEACTIVATE_UPDATE_API_RES:
      return {
        ...state,
        loading: false,
        appointmentListRes: {} as AppointmentDeactivateResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
